/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated by scripts/generate-offline-data.js
 */
window.OFFLINE_EXCEL_DATA = {
  "CONTEXTOS": [],
  "CUMPLEAÑOS": [
    [
      "Nivel",
      "Operación",
      "Numero",
      "Enunciado",
      "Nombre_Imagen",
      "Resultado",
      "Calculo",
      "Frases_Datos"
    ],
    [
      "Aprendiz",
      "Suma",
      1,
      "Hay 5 globos azules y 4 globos amarillos. ¿Cuántos globos hay en total?",
      "cumpleaños_aps_1.jpg",
      9,
      "$5 + 4 = 9$",
      "[\"5 globos azules\",\"4 globos amarillos\"]"
    ],
    [
      "Aprendiz",
      "Suma",
      2,
      "En la mesa hay 6 trozos de tarta y mamá trae 2 trozos más. ¿Cuántos trozos de tarta hay ahora?",
      "cumpleaños_aps_2.jpg",
      8,
      "$6 + 2 = 8$",
      "[\"6 trozos de tarta\",\"2 trozos más\"]"
    ],
    [
      "Aprendiz",
      "Suma",
      3,
      "Hace un momento llegaron 4 amigos y ahora llegan 4 amigos más. ¿Cuántos amigos han llegado en total?",
      "cumpleaños_aps_3.jpg",
      8,
      "$4 + 4 = 8$",
      "[\"4 amigos\",\"4 amigos más\"]"
    ],
    [
      "Aprendiz",
      "Suma",
      4,
      "Tengo 5 gorritos de fiesta y papá compra 2 gorritos más. ¿Cuántos gorritos tendré?",
      "cumpleaños_aps_4.jpg",
      7,
      "$5 + 2 = 7$",
      "[\"5 gorritos de fiesta\",\"2 gorritos más\"]"
    ],
    [
      "Aprendiz",
      "Suma",
      5,
      "En la mesa hay 10 vasos con zumo de naranja y nos traen 4 vasos de zumo más. ¿Cuántos vasos tendremos ahora?",
      "cumpleaños_aps_5.jpg",
      14,
      "$10 + 4 = 14$",
      "[\"10 vasos con zumo\",\"4 vasos de zumo\"]"
    ],
    [
      null,
      null,
      1
    ],
    [
      "Aprendiz",
      "Resta",
      2,
      "Me han hecho 9 regalos y ya he abierto 5 regalos. ¿Cuántos regalos faltan por abrir?",
      "cumpleaños_apr_2.jpg",
      4,
      "$9 - 5 = 4$",
      "[\"9 regalos\",\"5 regalos\"]"
    ],
    [],
    [],
    [],
    [
      "Avanzado",
      "Suma",
      1,
      "Hay 14 servilletas y la abuela pone 4 servilletas más. ¿Cuántas servilletas tendremos ahora?",
      "cumpleaños_avs_1.jpg",
      18,
      "$14 + 4 = 18$",
      "[\"14 servilletas\",\"4 servilletas más\"]"
    ],
    [],
    [
      "Avanzado",
      "Suma",
      3,
      "Tengo 10 tenedores de plástico y compro 7 tenedores más. ¿Cuántos tenedores tendré?",
      "cumpleaños_avs_3.jpg",
      17,
      "$10 + 7 = 17$",
      "[\"10 tenedores de plástico\",\"7 tenedores más\"]"
    ],
    [],
    [
      "Avanzado",
      "Suma",
      5,
      "Había 14 globos inflados y mi primo infla 4 globos más. ¿Cuántos globos hay ahora?",
      "cumpleaños_avs_5.jpg",
      18,
      "$14 + 4 = 18$",
      "[\"14 globos inflados\",\"4 globos más\"]"
    ],
    [
      null,
      null,
      1
    ],
    [
      "Avanzado",
      "Resta",
      2,
      "El el plato teníamos 15 galletas, pero, 4 galletas  se han roto al sacarlas. ¿Cuántas galletas quedan?",
      "cumpleaños_avr_2.jpg",
      11,
      "$15 - 4 = 11$",
      "[\"15 galletas\",\"4 galletas  se\"]"
    ],
    [],
    [
      "Avanzado",
      "Resta",
      4,
      "Habíamos preparado 18 botellas de agua y nos hemos bebido 5 botellas. ¿Cuántas botellas de agua quedan?",
      "cumpleaños_avr_4.jpg",
      13,
      "$18 - 5 = 13$",
      "[\"18 botellas de agua\",\"5 botellas\"]"
    ],
    [],
    [
      "Experto",
      "Suma",
      1,
      "¡Qué bien huelen los cupcakes! Tenemos 21 cupcakes de vainilla y otros 14 cupcakes de fresa. ¿Cuántos cupcakes hay en total?",
      "cumpleaños_exs_1.jpg",
      35,
      "$21 + 14 = 35$",
      "[\"21 cupcakes de vainilla\",\"14 cupcakes de fresa\"]"
    ],
    [],
    [
      "Experto",
      "Suma",
      3,
      "Mis padres han comprado muchos zumos para la fiesta. Hay 25 zumos de naranja y 22 de melocotón. ¿Cuántos zumos han comprado?",
      "cumpleaños_exs_3.jpg",
      47,
      "$25 + 22 = 47$",
      "[\"25 zumos de naranja\",\"22 de melocotón\"]"
    ],
    [
      "Experto",
      "Suma",
      4,
      "Teníamos 8 trozos de sandía, pero, como está tan rica, han traído 3 trozos de sandía más. ¿Cuántos trozos hay en total?",
      "cumpleaños_exs_4.jpg",
      11,
      "$8 + 3 = 11$",
      "[\"8 trozos de sandía\",\"3 trozos de sandía\"]"
    ],
    [],
    [
      "Experto",
      "Resta",
      1,
      "La tarta se ve estupenda, pero antes nos comeremos los sándwiches.Había 48 sándwiches y mis amigos ya se han comido 15 sándwiches. ¿Cuántos sándwiches quedan?",
      "cumpleaños_exr_1.jpg",
      33,
      "$48 - 15 = 33$",
      "[\"48 sándwiches\",\"15 sándwiches\"]"
    ],
    [
      "Experto",
      "Resta",
      2,
      "Antes de cantar \"Cumpleaños Feliz\", vamos a repartir los gorros de cartón. Había 38 gorros de cartón y ya hemos repartido 14 gorros. ¿Cuántos gorros quedan?",
      "cumpleaños_exr_2.jpg",
      24,
      "$38 - 14 = 24$",
      "[\"38 gorros de cartón\",\"14 gorros\"]"
    ]
  ],
  "FRUTERÍA": [
    [
      "Nivel",
      "Operación",
      "Numero",
      "Enunciado",
      "Nombre_Imagen",
      "Resultado",
      "Calculo",
      "Frases_Datos"
    ],
    [
      "Aprendiz",
      "Suma",
      1,
      "En una cesta hay 5 manzanas rojas y el agricultor trae 4 peras grandes. ¿Cuántas frutas hay?",
      "fruteria_aps_1.jpg",
      9,
      "$5 + 4 = 9$",
      "[\"5 manzanas rojas\",\"4 peras grandes\"]"
    ],
    [
      "Aprendiz",
      "Suma",
      2,
      "Primero compramos 5 zanahorias y después compramos 2 brócolis buenísimos. ¿Cuántas verduras hemos comprado?",
      "fruteria_aps_2.jpg",
      7,
      "$5 + 2 = 7$",
      "[\"5 zanahorias\",\"2 brócolis buenísimos\"]"
    ],
    [],
    [
      "Aprendiz",
      "Resta",
      1,
      "Había 8 tomates rojos en la caja, pero 3 tomates estaban estropeados. ¿Cuántos tomates estaban bien?",
      "fruteria_apr_1.jpg",
      5,
      "$8 - 3 = 5$",
      "[\"8 tomates rojos\",\"3 tomates estaban\"]"
    ],
    [],
    [
      "Aprendiz",
      "Resta",
      3,
      "En la tienda hay 9 limones y el frutero ha cogido 2 limones para hacer más zumo. ¿Cuántos limones han sobrado?",
      "fruteria_apr_3.jpg",
      7,
      "$9 - 2 = 7$",
      "[\"9 limones\",\"2 limones para hacer\"]"
    ],
    [
      "Avanzado",
      "Suma",
      1,
      "Hay 12 hueveras de cartón y el empleado trae 5 hueveras más para colocarlas en la estantería. ¿Cuántas hueveras hay ahora?",
      "fruteria_avs_1.jpg",
      17,
      "$12 + 5 = 17$",
      "[\"12 hueveras de cartón\",\"5 hueveras más\"]"
    ],
    [
      "Avanzado",
      "Suma",
      2,
      "En el mostrador hay 13 racimos de uvas y en la mesa hay 6 racimos más. ¿Cuántos racimos hay en total?",
      "fruteria_avs_2.jpg",
      19,
      "$13 + 6 = 19$",
      "[\"13 racimos de uvas\",\"6 racimos más\"]"
    ],
    [],
    [
      "Avanzado",
      "Resta",
      1,
      "En la tienda tenían 16 sacos de patatas y los clientes compraron 6 sacos. ¿Cuántos sacos quedan ahora?",
      "fruteria_avr_1.jpg",
      10,
      "$16 - 6 = 10$",
      "[\"16 sacos de patatas\",\"6 sacos\"]"
    ],
    [
      "Avanzado",
      "Resta",
      2,
      "Había 14 botes de espárragos y el tendero ha vendido 4 botes. ¿Cuántos botes quedan aún?",
      "fruteria_avr_2.jpg",
      10,
      "$14 - 4 = 10$",
      "[\"14 botes de espárragos\",\"4 botes\"]"
    ],
    [],
    [
      "Experto",
      "Suma",
      1,
      "Nos encanta comer sandía y vamos a ir a comprar. En la frutería había 22 sandías y un camión trajo 13 sandías más. ¿Cuántas sandías habrán?",
      "fruteria_exs_1.jpg",
      35,
      "$22 + 13 = 35$",
      "[\"22 sandías\",\"13 sandías más\"]"
    ],
    [
      "Experto",
      "Suma",
      2,
      "Nos faltan naranjas para hacer zumo de naranja para todos, así que, iremos a comprarlas. Cogimos 32 naranjas grandes y 18 naranjas pequeñas. ¿Cuántas naranjas cogimos?",
      "fruteria_exs_2.jpg",
      40,
      "$32 + 18 = 40$",
      "[\"32 naranjas grandes\",\"18 naranjas pequeñas\"]"
    ],
    [],
    [
      "Experto",
      "Resta",
      1,
      "Las espinacas de esta frutería son estupendas. En la estantería había 47 bolsas de espinacas y los clientes compraron 15 bolsas. ¿Cuántas bolsas de espinacas quedan?",
      "fruteria_exr_1.jpg",
      62,
      "$47 - 15 = 62$",
      "[\"47 bolsas de espinacas\",\"15 bolsas\"]"
    ],
    [
      "Experto",
      "Resta",
      2,
      "Una de las especialidades de esta frutería son las cerezas. Por la mañana había 37 cajas de cerezas, pero, en total, se vendieron 17 cajas. ¿Cuántas cajas de cerezas quedarán aún?",
      "fruteria_exr_2.jpg",
      20,
      "$37 - 17 = 20$",
      "[\"37 cajas de cerezas\",\"17 cajas\"]"
    ]
  ],
  "GRANJA": [
    [
      "Nivel",
      "Operación",
      "Numero",
      "Enunciado",
      "Nombre_Imagen",
      "Resultado",
      "Calculo",
      "Frases_Datos"
    ],
    [
      "Aprendiz",
      "Suma",
      1,
      "En el gallinero había 3 pollitos amarillos. De repente, la gallina trajo 2 pollitos más. ¿Cuántos pollitos hay en total en el gallinero?",
      "granja_aps_1.jpg",
      5,
      "$3 + 2 = 5$",
      "[\"3 pollitos amarillos\",\"2 pollitos más\"]"
    ],
    [
      "Aprendiz",
      "Suma",
      2,
      "Lucas ha recogido 4 manzanas rojas del árbol. Luego su hermana le regala 3 manzanas verdes. ¿Cuántas manzanas tiene Lucas en total?",
      "granja_aps_2.jpg",
      7,
      "$4 + 3 = 7$",
      "[\"4 manzanas rojas\",\"3 manzanas verdes\"]"
    ],
    [
      "Aprendiz",
      "Resta",
      1,
      "En el prado había 6 vacas comiendo hierba. Al cabo de un rato, 2 vacas entraron al establo a descansar. ¿Cuántas vacas quedan en el prado?",
      "granja_apr_1.jpg",
      4,
      "$6 - 2 = 4$",
      "[\"6 vacas comiendo hierba\",\"2 vacas al establo\"]"
    ],
    [
      "Aprendiz",
      "Resta",
      2,
      "En una cesta había 5 huevos recién recogidos. Mientras los llevaban a la cocina, 1 huevo se rompió. ¿Cuántos huevos enteros quedan en la cesta?",
      "granja_apr_2.jpg",
      4,
      "$5 - 1 = 4$",
      "[\"5 huevos recién recogidos\",\"1 huevo roto\"]"
    ],
    [
      "Avanzado",
      "Suma",
      1,
      "En el almacén de la granja había una caja marcada con el número 12 llena de zanahorias. Lucas trae 5 zanahorias más recién cosechadas. ¿Cuántas zanahorias hay en total?",
      "granja_avs_1.jpg",
      17,
      "$12 + 5 = 17$",
      "[\"12 zanahorias en la caja\",\"5 zanahorias más\"]"
    ],
    [
      "Avanzado",
      "Suma",
      2,
      "En una caja del granjero había 14 tomates rojos. La granjera coloca 6 tomates más que acaba de coger del huerto. ¿Cuántos tomates hay en total?",
      "granja_avs_2.jpg",
      20,
      "$14 + 6 = 20$",
      "[\"14 tomates en la caja\",\"6 tomates más\"]"
    ],
    [
      "Avanzado",
      "Resta",
      1,
      "En la despensa de la granja había una caja grande con 15 tarros de miel. El granjero vendió 4 tarros a unos vecinos. ¿Cuántos tarros de miel quedan en la despensa?",
      "granja_avr_1.jpg",
      11,
      "$15 - 4 = 11$",
      "[\"15 tarros de miel\",\"4 tarros vendidos\"]"
    ],
    [
      "Avanzado",
      "Resta",
      2,
      "En el granero había un saco rústico marcado con el número 18 lleno de mazorcas de maíz. Las gallinas se comieron 5 mazorcas durante la mañana. ¿Cuántas mazorcas quedan en el saco?",
      "granja_avr_2.jpg",
      13,
      "$18 - 5 = 13$",
      "[\"18 mazorcas en el saco\",\"5 mazorcas comidas\"]"
    ],
    [
      "Experto",
      "Suma",
      1,
      "En el cobertizo de la granja había 2 cajas grandes marcadas con el número 10 llenas de sandías y 3 sandías sueltas. El granjero trae 1 caja más de 10 sandías y 2 sandías sueltas. ¿Cuántas sandías hay en total?",
      "granja_exs_1.jpg",
      35,
      "$23 + 12 = 35$",
      "[\"23 sandías en el cobertizo\",\"12 sandías más\"]"
    ],
    [
      "Experto",
      "Suma",
      2,
      "En el gallinero había 3 hueveras marcadas con el número 10 llenas de huevos y 4 huevos sueltos. La granjera recoge 1 huevera más de 10 huevos y 2 huevos sueltos. ¿Cuántos huevos hay en total?",
      "granja_exs_2.jpg",
      46,
      "$34 + 12 = 46$",
      "[\"34 huevos en el gallinero\",\"12 huevos más\"]"
    ],
    [
      "Experto",
      "Resta",
      1,
      "En el almacén de la granja había 3 cajas enormes marcadas con el número 10 llenas de calabazas y 6 calabazas sueltas. Se vendieron 1 caja de 10 calabazas y 2 calabazas sueltas. ¿Cuántas calabazas quedan en el almacén?",
      "granja_exr_1.jpg",
      24,
      "$36 - 12 = 24$",
      "[\"36 calabazas grandes\",\"12 calabazas vendidas\"]"
    ],
    [
      "Experto",
      "Resta",
      2,
      "En la despensa de la granja había 4 cestas marcadas con el número 10 llenas de manzanas y 5 manzanas sueltas. Las ovejas se comieron 1 cesta de 10 manzanas y 3 manzanas sueltas. ¿Cuántas manzanas quedan en la despensa?",
      "granja_exr_2.jpg",
      32,
      "$45 - 13 = 32$",
      "[\"45 manzanas en la despensa\",\"13 manzanas comidas\"]"
    ]
  ]
};
console.log('✅ Datos offline cargados (4 hojas)');
